import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';
import { BaseScale } from '../model/types';

interface IncomeStatisticsFilters {
  warehouseId?: string;
  isApplicable?: boolean;
  startDate?: string;
  endDate?: string;
  scale?: BaseScale;
}

export const transformIncomeStatisticsFilters = ({
  selectedWarehouses,
  isApplicable,
  startDate,
  endDate,
  scale,
}: TableFilterType): IncomeStatisticsFilters => {
  return {
    warehouseId: selectedWarehouses?.value || undefined,
    isApplicable: isApplicable?.value === undefined ? undefined : isApplicable?.value === 'applicable',
    startDate: getFilterServerFormatDate(startDate?.value),
    endDate: getFilterServerFormatDate(endDate?.value),
    scale: scale?.value || undefined,
  };
};
